import Vue from 'vue';
import store from '@/store';
import moment from 'moment';

export default {
  init() {
    Vue.filter('currencyFormat', function(value) {
      if (value) {
        if (store.state.countrySelected.currency.order === 'before') {
          return `${store.state.countrySelected.currency.code}${value}`;
        }
        return `${value}${store.state.countrySelected.currency.code}`;
      }
      return '';
    });

    Vue.filter('formatDatePark', function(value) {
      if (value === null) {
        return '';
      }
      return moment(value).format('DD MMMM, YYYY');
    });

    Vue.filter('formatDateMaxAvailabilityPark', function(value) {
      if (value === null) {
        return '';
      }
      return moment(value).format('DD MMMM, YYYY, HH:mm');
    });

    Vue.filter('formatDateTimeAsLocal', function (value) {
      if (value === null) {
        return '';
      }
      return moment(value).format('DD/MM/YYYY HH:mm');
    });

    Vue.filter('formatDateAsUtc', function (value, locale) {
      if (value === null) {
        return '';
      }
      // El idioma se puede pasar explicito: desde un computed no vale confiar
      // en el locale global de moment, porque Vue cachea por dependencias y la
      // fecha se quedaria con el idioma anterior al cambiar de lengua.
      const date = moment.utc(value);
      if (locale) {
        date.locale(locale);
      }
      return date.format('DD MMMM, YYYY, HH:mm');
    });

    Vue.filter('formatDate', function(value) {
      if (value === null) {
        return '';
      }
      return moment(value).format('DD MMMM, YYYY');
    });

    Vue.filter('formatTime', function(value) {
      if (value === null) {
        return '';
      }
      return moment(value).format('HH:mm');
    });

    Vue.filter('formatTimeRounded', function(value) {
      if (value === null) {
        return '';
      }
      let now = moment(value);
      let minutes = now.minutes();
      let hours = now.hours();
      if (minutes === 0) {
        minutes = 0;
      } else if (minutes <= 5) {
        minutes = 5;
      } else if (minutes <= 10) {
        minutes = 10;
      } else if (minutes <= 15) {
        minutes = 15;
      } else if (minutes <= 20) {
        minutes = 20;
      } else if (minutes <= 25) {
        minutes = 25;
      } else if (minutes <= 30) {
        minutes = 30;
      } else if (minutes <= 35) {
        minutes = 35;
      } else if (minutes <= 40) {
        minutes = 40;
      } else if (minutes <= 45) {
        minutes = 45;
      } else if (minutes <= 50) {
        minutes = 50;
      } else if (minutes <= 55) {
        minutes = 55;
      } else {
        minutes = 0;
        if (hours === 23) {
          hours = 0;
          this.form.day = moment().add(1, 'day').format('YYYY-MM-DD');
        } else {
          hours++;
        }
      }
      return `${hours.toString().padStart(2, '0')}:${minutes
        .toString()
        .padStart(2, '0')}`;
    });

    Vue.filter('formatDistance', function(value) {
      if (value === null) {
        return '';
      }
      let temp = Number(Math.trunc(value));
      let km = temp / 1000;
      if (km < 1) {
        return `${temp.toLocaleString()} m`;
      }
      return `${km.toFixed(2).toLocaleString()} Km`;
    });

    Vue.filter('addCurrencySymbol', function(value) {
      if (store.state.countrySelected.currency.order === 'before') {
        return `${store.state.countrySelected.currency.code}${value}`;
      } else {
        return `${value}${store.state.countrySelected.currency.code}`;
      }
    });
  }
};
